




























































































































































































































































































import {
  Component,
  Vue, Watch,
} from 'vue-property-decorator';
import SubscriptionsService from '@/services/subscriptions.service';
import {
  CommercialAccount, ConsolidatedSubscriptionOrder,
  SimCard, SubscriptionCounts,
  SubscriptionOrder,
  SubscriptionProduct,
} from '@/types';
import Table from '@/components/Table.vue';
import Dialog from '@/components/Dialog.vue';
import {generateLuhnForIccid} from '@/helpers/luhn';
import {isActivateByPassed} from '@/helpers/subscription';
import BarcodeScanner from '@/components/BarcodeScanner.vue';
import SimService from '@/services/sim.service';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import GenericButton from '@/components/GenericButton.vue';
import AddSubscriptionOrderForm from '@/components/subscriptions/AddSubscriptionOrderForm.vue';
import {Action, Getter} from 'vuex-class';
import { copyToClipboard } from '@/classes/utils';
import AccOrgAutocomplete from '@/components/AccOrgAutocomplete.vue';
import Decimal from 'decimal.js';
import {unparse} from 'papaparse';
import {saveAs} from 'file-saver';
import MultiOrgSubscriptionOrder from '@/components/subscriptions/MultiOrgSubscriptionOrder.vue';
import AccountService from '@/services/account.service';
import Transformation from '@/classes/transformation';

@Component({
  components: {
    MultiOrgSubscriptionOrder,
    AccOrgAutocomplete,
    AddSubscriptionOrderForm,
    GenericButton,
    ConfirmButton,
    CancelButton,
    BarcodeScanner,
    Table,
    Dialog,
  },
})
export default class SubscriptionOrders extends Vue {
  @Action private clearToastErrorMessages: any;
  @Getter private hasPermission: any;
  @Getter private organisations: any;
  private subscriptionOrders: ConsolidatedSubscriptionOrder[] = [];
  private products: SubscriptionProduct[] = [];
  private showAddEditDialog: boolean = false;
  private showAllocationDialog: boolean = false;
  private orderFormValid: boolean = false;
  private accOrOrgSelected: {id: number; is_org: boolean} | null = null;
  private expanded: any = [];

  private itemsPerPage: number = 100;
  private perPage: number = 100;
  private page: number = 1;
  private singleExpand: boolean = true;
  private hideLapsed: boolean = true;
  private searchName: string = '';
  private queryData: any = { sort: ['suborder.order_number'] };
  private errorMsg: string = '';
  private alertActive: boolean = false;
  private sequenceError: any = { };
  private isValid: boolean = true;
  private loading: boolean = true;
  private editing: boolean = true;
  private selectedSubscriptionOrder: ConsolidatedSubscriptionOrder | null = null;
  private batchData: {[ key: string ]: string } = {};
  private dataTableHeight: number = 100;
  private simsForOrder: SimCard[] = [];
  private accounts: CommercialAccount[] = [];
  private simHeaders: any[] = [
    {text: 'ICCID', value: 'iccid', width: '19%'},
    {text: '', value: 'type', width: '5%', align: 'center'},
    {text: 'Identifier', value: 'identifier'},
    {text: 'Organisation', value: 'organisation'},
    {text: 'Subscription', value: 'subscription'},
  ];

  private csvColumns = [
    'Order number',
    'Account',
    'Subscription product',
    'Activate by',
    'Term length (days)',
    'Total subs',
    'Activated subs',
    'Remaining subs',
    'Total stock / unsubbed',
    'Spot price',
  ];

  private tableData: any = {
    headers: [
      { text: '', value: 'data-table-expand', sortable: false, class: 'sticky-expand-column' },
      {
        text: 'Order reference',
        value: 'orderNumber',
        align: 'start',
        filterable: false,
        sortable: true,
        querySortKey: 'suborder.order_number',
      },
      {
        text: 'Account',
        value: 'account',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'accounts',
        querySortKey: 'commercial_account.name',
      },
      {
        text: 'Subscription product',
        value: 'subscriptionProductName',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'subscriptionProducts',
        querySortKey: 'subscription_product.name',
      },
      {
        text: 'Activate by',
        value: 'activateBy',
        align: 'start',
        filterable: false,
        sortable: true,
        querySortKey: 'suborder.activate_by',
      },
      {
        text: 'Term length',
        value: 'termLength',
        align: 'start',
        filterable: false,
        sortable: true,
        querySortKey: 'subscription_product.term_length',
      },
      {
        text: 'Spot price',
        value: 'spotPrice',
        align: 'start',
        filterable: false,
        sortable: false,
      },
      {
        text: 'Available',
        value: 'availableSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        querySortKey: 'availableSubscriptions',
        tooltipText: 'Not yet activated',
      },
      {
        text: 'Active',
        value: 'activeSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        querySortKey: 'activeSubscriptions',
        tooltipText: 'Currently active',
      },
      {
        text: 'Detached',
        value: 'detachedSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        querySortKey: 'detachedSubscriptions',
        tooltipText: 'Activated but not linked to a device',
      },
      {
        text: 'Lapsed',
        value: 'lapsedSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        querySortKey: 'lapsedSubscriptions',
        tooltipText: 'Not activated but past activation date',
      },
      {
        text: 'Not renewing',
        value: 'notRenewingSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        querySortKey: 'notRenewingSubscriptions',
        tooltipText: 'Will not auto renew',
      },
      {
        text: 'Expired',
        value: 'expiredSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        querySortKey: 'expiredSubscriptions',
        tooltipText: 'Activated but past expiration date',
      },
      {
        text: 'Total',
        value: 'totalSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        querySortKey: 'totalSubscriptions',
        tooltipText: 'Total subscriptions for this order',
      },
      {
        text: '',
        value: 'actions',
        class: 'sticky-column',
        filterable: false,
        sortable: false,
      },
    ],
  };
  private copyToClipboard: (text: string) => boolean = copyToClipboard;
  private order: SubscriptionOrder = {} as SubscriptionOrder;
  private simsToAllocate: Array<{[ key: string ]: string | number | boolean}> = [];
  private launchScanner: boolean = false;
  private scanTarget: string = '';

  @Watch('accOrOrgSelected')
  private onAccOrgFilter() {
    this.loadData();
  }

  @Watch('showAllocationDialog')
  private async onShowDialog() {
    if (this.showAllocationDialog && this.selectedSubscriptionOrder) {
      this.loading = true;
      try {
        this.simsForOrder = await SubscriptionsService.getSimsForSubscriptionOrder(this.selectedSubscriptionOrder.id);
      } finally {
        this.loading = false;
      }
    }
  }

  private async loadAccounts() {
    this.accounts = await AccountService.getUserAccounts();
  }

  private async mounted() {
    this.simsToAllocate.push({ start_iccid: '', end_iccid: ''});
    await Promise.all([this.loadData(), this.loadProducts(), this.loadAccounts()]);
  }

  private get iccidBarcodeScannerEnabled() {
    return !!process.env.VUE_APP_FEATURE_ICCID_BARCODE_SCANNING;
  }

  private get iccidRules() {
    return [
      ((v: string) => !!v && v.length > 18 && v.length < 22 || 'ICCID must be between 18 and 22 characters.'),
      ((v: string) => !!v && !(this.simsForOrder.map((s: SimCard) => s.iccid)).includes(v) || 'ICCID has already been allocated'),
    ];
  }

  private async checkSequence(index: number) {
    if (!this.simsToAllocate[index].start_iccid || !this.simsToAllocate[index].end_iccid) {
      return;
    }
    const { success, message } = await SimService.checkSequence({start: this.simsToAllocate[index].start_iccid, end: this.simsToAllocate[index].end_iccid});
    if (!success) {
      Vue.set(this.sequenceError, index, []);
      this.sequenceError[index].push(message);
    } else {
      Vue.set(this.sequenceError, index, []);
    }
  }

  private updateDataTableHeight() {
    this.dataTableHeight = (this.$refs.subs as any).$el.clientHeight - 59;
  }

  private async loadProducts() {
    const products = await SubscriptionsService.getSubscriptionProducts();
    Vue.set(this, 'products', products);
  }

  private async loadData(
      queryData: {
        take?: number;
        skip?: number;
        sort?: string | string[];
        desc?: boolean;
        filters?: { [key: string]: any }; } = this.queryData,
      search: string = this.searchName) {
    this.loading = true;

    const mappedFilters: {
      [key: string]: { [key: string]: boolean },
    } = Transformation.tableFiltersToMap(queryData.filters);
    const take = !queryData.take || queryData.take === 0 ? this.perPage : queryData.take;

    if (this.accOrOrgSelected) {
      if (this.accOrOrgSelected.is_org) {
        mappedFilters.organisations = {};
        mappedFilters.organisations[this.accOrOrgSelected.id] = true;
      } else {
        mappedFilters.accounts = {};
        mappedFilters.accounts[this.accOrOrgSelected.id] = true;
      }
    }

    try {
      const {
        orders,
        total,
        columnFilters,
      }: any = await SubscriptionsService.getOrganisationSubscriptionOrders(!this.hideLapsed, take, queryData.skip, queryData.sort, queryData.desc, mappedFilters, search);
      Vue.set(this, 'subscriptionOrders', orders);
      await this.formatSubscriptionOrders();
      this.tableData.total = total;
      Transformation.setTableFilterValues(this.tableData.headers, columnFilters);
    } finally {
      this.loading = false;
    }
  }

  private addSubscriptionOrder() {
    this.selectedSubscriptionOrder = null;
    this.editing = false;
    this.showAddEditDialog = true;
  }

  private async formatSubscriptionOrders() {
    const rows: any[] = [];
    this.subscriptionOrders.forEach((order: any, index: number) => {
      const accountName = order.commercial_account ? order.commercial_account.name : 'No Account';
      rows.push({
        ...order,
        id: order.id,
        index,
        accountName,
        subscriptionProductName: order.subscriptionProduct.name,
        subscriptionProduct: order.subscriptionProduct,
        termLength: order.subscriptionProduct!.term_length,
        remainingSubscriptions: isActivateByPassed(order.activateBy) ? '' : order.totalSubscriptions - order.activeSubscriptions,
        activatedSubscriptions: order.activeSubscriptions,
        totalSimCards: order.totalSimCards,
      });
    });
    Vue.set(this.tableData, 'rows', rows);
  }

  private async handleRowClicked(row: any) {
    this.selectedSubscriptionOrder = this.subscriptionOrders[row.index];
    this.editing = true;
    this.showAddEditDialog = true;
  }

  private filterSubscriptionsTable(row: SubscriptionOrder) {
    this.$router.push({name: 'subscriptions', params: { subscriptionOrderId: row.id.toString() }});
  }

  private async onQueryDataUpdate(data: object) {
    this.queryData = data;
    await this.loadData(data);
  }

  private async closeAddEditDialog() {
    await (this.$refs.orderForm as AddSubscriptionOrderForm).save();
  }

  private closeAllocation() {
    this.showAllocationDialog = false;
    this.simsToAllocate = [{ start_iccid: '', end_iccid: ''}];
    this.errorMsg = '';
    this.sequenceError = {};
  }

  // Duplicate

  private async handleCRInDialog(event: any, target: string) {
    if (!event || event.key !== 'Enter' || !target || !target.length) {
      return;
    }
    if (this.$refs[target]) {
      if (target === `addRow`) {
        this.$nextTick(() => {
          (this.$refs[target] as any)[0].$el.focus();
        });
        return;
      } else {
        this.$nextTick(() => {
          (this.$refs[target] as any)[0].focus();
        });
      }
    }
  }

  private async allocateBatches(subscriptionOrderId: number) {
    this.loading = true;
    try {
      const payload = {
        batches: this.simsToAllocate.filter((batch) => {
          if (batch.start_iccid && batch.end_iccid) {
            return {
              start_iccid: batch.start_iccid,
              end_iccid: batch.end_iccid,
            };
          }
        }),
        subscription_order_id: subscriptionOrderId,
      };
      const res = await SimService.allocateBatchesToOrder(payload);
      this.simsToAllocate = [];
      this.simsToAllocate.push({start_iccid: '', end_iccid: ''});
    } catch (e: any) {
      this.isValid = false;
      this.alertActive = true;
      this.clearToastErrorMessages();
      const error = e.response.data.error;
      if (error.includes('Invalid start')) {
        this.errorMsg = 'Failed to allocate ICCIDs to the subscription order. Invalid start ICCID.';
      } else if (error.includes('Invalid end')) {
        this.errorMsg = 'Failed to allocate ICCIDs to the subscription order. Invalid end ICCID.';
      } else if (error.includes('Range exceeds')) {
        this.errorMsg = 'Failed to allocate ICCIDs to the subscription order. Total SIMs exceeds maximum number of available subscriptions.';
      } else if (error.includes('Maximum subscriptions')) {
        this.errorMsg = 'Failed to allocate ICCIDs to the subscription order. Maximum subscriptions reached.';
      } else if (error.includes('SIMs in the range')) {
        this.errorMsg = 'Failed to allocate ICCIDs to the subscription order. One or more SIMs are not in stock.';
      } else {
        this.errorMsg = 'Failed to allocate ICCIDs to the subscription order.';
      }
    } finally {

      try {
        if (this.isValid) {
          this.simsToAllocate = [{ start_iccid: '', end_iccid: ''}];
          this.errorMsg = '';

          if (this.$refs) {
            (this.$refs.allocationStockForm_0 as any)[0].resetValidation();
          }
          await this.loadData();
          await this.onShowDialog();
        }
      } finally {
        this.isValid = true;
        this.loading = false;
      }
    }
  }

  private clearValidation() {
    this.loading = false;
    for (const form in this.$refs) {
      if (this.$refs.hasOwnProperty(form) && form.includes('allocationStockForm')) {
        (this.$refs[form] as any)[0].resetValidation();
      }
    }
    this.isValid = true;
    this.errorMsg = '';
  }

  private getIccidValues(row: any) {
    const iccids: any = {
      start_iccid: row.start_iccid,
      start_iccid_no_checksum: row.start_iccid.substring(0, row.start_iccid.length - 1),
      start_checksum: generateLuhnForIccid(row.start_iccid.substring(0, row.start_iccid.length - 1)),
      end_iccid: row.end_iccid,
      end_iccid_no_checksum: row.end_iccid.substring(0, row.end_iccid.length - 1),
      end_checksum: generateLuhnForIccid(row.end_iccid.substring(0, row.end_iccid.length - 1)),
      startCommon: row.start_iccid.substring(0, row.start_iccid.length - 6),
      startUnique: row.start_iccid.substring(row.start_iccid.length - 6, row.start_iccid.length - 1),
      endCommon: row.end_iccid.substring(0, row.end_iccid.length - 6),
      endUnique: row.end_iccid.substring(row.end_iccid.length - 6, row.end_iccid.length - 1),
    };
    row.count = this.rangeCount(iccids);
    this.batchData = row;
    return {...iccids, count: row.count};
  }

  private rangeCount(iccids: any) {
    const startUnique = iccids.start_iccid_no_checksum.substring(iccids.start_iccid_no_checksum.length - 6);
    const endUnique = iccids.end_iccid_no_checksum.substring(iccids.end_iccid_no_checksum.length - 6);

    return iccids.startCommon === iccids.endCommon ? (Number(endUnique) - Number(startUnique)) + 1 : 0;
  }

  private removeFromAllocating(index: number) {
    this.simsToAllocate.splice(index, 1);
    (this.$refs[`allocationStockForm_${index}`] as any)[0].resetValidation();
    this.sequenceError[index] = [];

    if (this.simsToAllocate.length) {
      this.errorMsg = '';
    }
  }

  private onBarcodeScan(result: any) {
    if (!result || !result.v1 || !this.scanTarget || !this.scanTarget.length) {
      return;
    }
    this.batchData[this.scanTarget] = result.v1;
  }

  private get csvBatches(): string {
    let stringToBuild = '';
    for (const batch of this.simsToAllocate) {
      if (batch.start_iccid && batch.end_iccid) {
        stringToBuild += `${batch.start_iccid},${batch.end_iccid}\n`;
      }
    }
    return stringToBuild;
  }

  private get filteredOrders() {
    return this.tableData.rows;
  }

  private formatSpotPrice(spotPrice: Decimal) {
    if (spotPrice) {
      return Number(spotPrice).toFixed(2);
    }
  }

  private async download() {
    const downloadData = await this.getCsvData();
    if (!downloadData || !downloadData.length) {
      return;
    }
    // Convert to CSV
    let csv = unparse(
        downloadData,
        Object.assign(
            {
              delimiter: ',',
              encoding: 'utf-8',
              columns: this.csvColumns,
            },
        ),
    );
    // Add UTF-8 BOM
    csv = '\ufeff' + csv;
    const blob = new Blob([csv], {
      type: 'application/csvcharset=utf-8',
    });
    // File download
    saveAs(blob, 'subscription_orders.csv');
  }

  private async getCsvData() {
    this.loading = true;
    try {
      if (this.filteredOrders && this.filteredOrders.length) {
        return this.filteredOrders.map((r: any) => {
          return {
            'Order number': r.orderNumber,
            'Account': r.account.name || '[No Account]',
            'Subscription product': r.subscriptionProductName,
            'Activate by': this.$options.filters!.formatCSVDate(r.activateBy),
            'Term length': r.termLength,
            'Total subs': r.totalSubscriptions,
            'Activated subs': r.activatedSubscriptions,
            'Remaining subs': r.remainingSubscriptions,
            'Total stock / unsubbed': r.totalStockUnsubscribed,
            'Spot price': this.formatSpotPrice(r.spotPrice),
          };
        });
      } else {
        return [];
      }
    } finally {
      this.loading = false;
    }
  }

  private get allocationHeaders() {
    if (this.subscriptionOrders.every((o) => o.isManyToMany)) {
      return [
        { text: 'Organisation', value: 'organisationName', sortable: false },
        { text: 'Maximum subscriptions', value: 'allocatedSubscriptions', sortable: false },
        { text: 'Consumed subscriptions', value: 'consumedSubscriptions', sortable: false },
      ];
    }
    return [
      { text: 'Organisation', value: 'organisationName', sortable: false },
      { text: 'Maximum subscriptions', value: 'allocatedSubscriptions', sortable: false },
    ];
  }
}
